<div class="top-bar">
    <span class="page-header">{{ 'translation:Enquiry Registration' | i18next }}</span>
    <app-widget-textbox class="filter-box" [model]="filter" (modelChange)="filter=$event;filterCategories()"
        placeholder="{{ 'translation:Search categories' | i18next }}" textboxWidth="300px"></app-widget-textbox>
    <i class="fal fa-search"></i>
</div>
<div *ngIf="isDataLoaded" class="enquiry-container">
    <div class="category-list" cdkDropList (cdkDropListDropped)="drop($event)">
        <div class="category-list-actions-top">
            <div class="category-list-header">{{ 'translation:Categories' | i18next }}</div>
            <div>
                <button matButton [ngClass]="['primary-button', 'add-btn']" [disabled]="!isSaveDisabled"
                    (click)="addCategory()">{{ 'translation:Add category' |
                    i18next
                    }}</button>
            </div>
        </div>
        <div class="category-list-actions-bot">
            <button matButton [ngClass]="['secondary-button', 'undo-button']" [disabled]="isUndoDisabled"
                (click)="undoChanges()">{{ 'translation:Undo changes' |
                i18next }}</button>
            <button matButton [ngClass]="['primary-button', 'save-btn']" [disabled]="isSaveCategoryListDisabled"
                (click)="saveChanges()">{{ 'translation:Save' |
                i18next
                }}</button>
        </div>
        <div cdkDrag *ngFor="let category of mainCategoriesFiltered">
            <div class="category-name"
                [ngClass]="{'active-category' : category.categoryId == selectedCategory.categoryId}">
                <div cdkDragHandle class="category-description" (click)="selectCategory(category)">
                    <span>{{category.description}}</span>
                    <span class="global-setting-type"> {{category.globalSettingType}}</span>
                </div>
                <div class="category-global-settings">
                    <i class="fal fa-trash-alt" (click)="deleteCategory(category)"></i>
                </div>
            </div>
        </div>
    </div>
    <div class="category-details">
        <div class="category-details-header">{{ 'translation:Details for selected Category' | i18next }}</div>
        <app-category-details *ngIf="mainCategoriesFiltered.length > 0" [category]="selectedCategory"
            (isSaveDisabledEvent)="isSaveDisabledCheck($event)"></app-category-details>
        <div *ngIf="mainCategoriesFiltered.length === 0" class="empty-container"></div>
    </div>
</div>
<div *ngIf="!isDataLoaded" class="data-loading">
    <i class="fal fa-sync fa-spin --fa-animation-duration:2s;"></i>
    <span>{{ 'dashboard:Loading' | i18next }}...</span>
</div>